module.exports = __webpack_public_path__ + "static/17-79922068bc56b2847a16c6cc6fc0e165.png";